import { DeductionActivity } from "@/core/entities/deduction";

export enum DeductionActivitySortOrder {
  ASCEND = "ASCEND",
  DESCEND = "DESCEND",
}

export interface IDeductionActivityRepositoryParams {
  deduction_id: number;
  page_number: number;
  page_size: number;
  sort_order: DeductionActivitySortOrder;
}

export interface IDeductionActivityRepositoryResponse {
  deductionId: number;
  hasMore: boolean;
  deductionActivities: DeductionActivity[];
  total: number;
  page: number;
  limit: number;
}

export interface IExportDeductionActivityRepositoryRequest {
  params: {
    deduction_id: number;
    invoice_number: string;
    total_amount: number;
    sort_order: string;
    time_zone: string;
  };
  formats: {
    date_time: string;
  };
}
export interface IDeductionActivityRepository {
  getActivities(params: IDeductionActivityRepositoryParams): Promise<IDeductionActivityRepositoryResponse>;
  exportActivities(params: IExportDeductionActivityRepositoryRequest): Promise<{ signedUrl: string; success: boolean }>;
}
